import React, { FC, useEffect, useMemo, useState } from "react";
import { FloatingCard } from "./components/FloatingCard";
import { PlanningContainer } from "./components/PlanningContainer";
import {
  FRIDAY,
  MONDAY,
  THURSDAY,
  TUESDAY,
  WEDNESDAY,
  SATURDAY,
  SUNDAY,
  WeekdayPlanner,
  SendEmailButton, EnrichedTeamDayAvailability
} from "./components/WeekdayPlanner";
import { useTeamAvailability } from "./hooks/useTeamAvailability";
import { Button } from "@traas/lib/src/components/form/Button";
import { useApi } from "../api/APIContext";
import { usePlanner } from "./PlannerContext";
import { Callout } from "../../../lib/src/components/content/Callout";
import moment from "moment";

const WeekOverview: FC = () => {
  const teamAvailability = useTeamAvailability()
  const [canPlanWeekend, setCanPlanWeekend] = useState(false)
  const { getPlannedTasksForWeek, day, getPlannedTasksForDay } = usePlanner()

  useEffect(() => {
    const weekendTeams = (teamAvailability?.saturday.filter(t => t.teamId !== 'absence').length ?? 0) + (teamAvailability?.sunday.filter(t => t.teamId !== 'absence').length ?? 0)
    if (weekendTeams > 0) {
      setCanPlanWeekend(true)
    } else {
      const tasksOnSaturday = getPlannedTasksForDay(moment(day).day(SATURDAY).toDate())
      const tasksOnSunday = getPlannedTasksForDay(moment(day).day(SUNDAY).toDate())
      if (tasksOnSaturday.length > 0 || tasksOnSunday.length > 0) {
        setCanPlanWeekend(true)
      } else {
        setCanPlanWeekend(false)
      }
    }
  }, [teamAvailability, day, getPlannedTasksForDay]);
  const { teams } = useApi()

  const tasksThisWeek = useMemo(() => getPlannedTasksForWeek(day), [getPlannedTasksForWeek, day])

  const enrichtedTeamDayAvailabilitiesWithoutEmployeeMemberships = useMemo(() => {
    const teamMap = Object.fromEntries(teams.map(t => [t.id, t]))
    const teamDayAvailabilities = [
      teamAvailability?.monday ?? [],
      teamAvailability?.tuesday ?? [],
      teamAvailability?.wednesday ?? [],
      teamAvailability?.thursday ?? [],
      teamAvailability?.friday ?? [],
      teamAvailability?.saturday ?? [],
      teamAvailability?.sunday ?? [],
    ].flat()
    return teamDayAvailabilities.map(tda => ({
      ...tda,
      team: teamMap[tda.teamId],
    }) as EnrichedTeamDayAvailability)
  }, [teams, teamAvailability])

  return <PlanningContainer>
    <div className={"flex-1 flex flex-col"}>
      <WeekdayPlanner day={MONDAY} teamAvailabilities={teamAvailability?.monday} teamAbsences={teamAvailability?.monday.filter(t => t.teamId === 'absence')} />
      <WeekdayPlanner day={TUESDAY} teamAvailabilities={teamAvailability?.tuesday} teamAbsences={teamAvailability?.tuesday.filter(t => t.teamId === 'absence')} />
      <WeekdayPlanner day={WEDNESDAY} teamAvailabilities={teamAvailability?.wednesday} teamAbsences={teamAvailability?.wednesday.filter(t => t.teamId === 'absence')} />
      <WeekdayPlanner day={THURSDAY} teamAvailabilities={teamAvailability?.thursday} teamAbsences={teamAvailability?.thursday.filter(t => t.teamId === 'absence')} />
      <WeekdayPlanner day={FRIDAY} teamAvailabilities={teamAvailability?.friday} teamAbsences={teamAvailability?.friday.filter(t => t.teamId === 'absence')} />
      {canPlanWeekend ? <>
        <WeekdayPlanner day={SATURDAY} teamAvailabilities={teamAvailability?.saturday} teamAbsences={teamAvailability?.saturday.filter(t => t.teamId === 'absence')} />
        <WeekdayPlanner day={SUNDAY} teamAvailabilities={teamAvailability?.sunday} teamAbsences={teamAvailability?.sunday.filter(t => t.teamId === 'absence')} />
      </> : <>
        <div className={"text-xs mt-2 py-4 px-3 bg-slate-100 rounded-sm"}>
          <h2 className={"text-sm font-medium"}>Weekend vrij</h2>
          <p className={"text-slate-600 mb-2"}>Over het algemeen wordt er in de weekenden geen werk gepland. Bij uitzondering kan er toch een tijdelijk team ingepland worden.</p>
          <Button type={'primary'} size={'xs'} text={'Toch plannen dit weekend'} onClick={() => setCanPlanWeekend(true)} />
        </div>
      </>}
    </div>

    <Callout>
      <div className={'text-sm mb-1'}><strong>E-mail versturen</strong></div>
      <div className={'text-xs mb-2 text-slate-600'}>Verstuur een e-mail naar alle primaire contacten van projecten die deze week ingepland staan.</div>
      <SendEmailButton teamAvailabilities={enrichtedTeamDayAvailabilitiesWithoutEmployeeMemberships} tasksToday={tasksThisWeek} />
    </Callout>

    {/* Floating planning card */}
    <FloatingCard />
  </PlanningContainer>
}
export default WeekOverview





